const STORAGE_KEY = 'redirect';

const Redirect = {
    /**
     * @returns {boolean}
     */
    hasRedirect: () => {
        if (window.sessionStorage.getItem(STORAGE_KEY)) {
            return true;
        }

        return false;
    },

    /**
     * @returns {string}
     */
    get: () => {
        const value = window.sessionStorage.getItem(STORAGE_KEY);
        window.sessionStorage.removeItem(STORAGE_KEY);
        
        return value;
    },

    /**
     * @returns {void}
     */
    set: (url) => {
        if (!Redirect.hasRedirect()) {
            window.sessionStorage.setItem(STORAGE_KEY, url);
        }
    }
}

export default Redirect;
